import React, { FC, ReactNode, useState, useEffect } from 'react';
import { Modal } from 'semantic-ui-react';
import classNames from 'classnames';

import ErrorDisplay from 'components/ErrorDisplay';
import Loader from 'components/Loader';

import theme from './theme.scss';

export type ModalWithSidePanelProps = {
  name: string;
  loading?: boolean;
  error?: boolean;
  sections: {
    key: string;
    name: string;
    emoji: string;
    component: ReactNode;
  }[];
  onClose: () => void;
};

const ModalWithSidePanel: FC<ModalWithSidePanelProps> = ({
  name,
  loading,
  error,
  sections,
  onClose,
}) => {
  const [sectionOnDisplay, setSectionOnDisplay] = useState(sections[0]);

  useEffect(() => setSectionOnDisplay(sections[0]), [sections]);

  function sidePanel() {
    return (
      <div className={theme.navigation}>
        <p className={theme.modalName}>{name}</p>
        {sections.map(section => (
          <div
            className={classNames(
              theme.sectionSelect,
              section.key === sectionOnDisplay.key ? theme.active : null
            )}
            onClick={() => setSectionOnDisplay(section)}
            key={`section-select-${section.key}`}
          >
            <span role="img" aria-label="notepad" className={theme.emoji}>
              {section.emoji}
            </span>
            <span className={theme.sectionName}>{section.name}</span>
          </div>
        ))}
      </div>
    );
  }

  if (loading)
    return (
      <Modal open={true} size="small" className={theme.modalWithSidePanel} onClose={onClose}>
        <Loader />
      </Modal>
    );

  if (error || !sectionOnDisplay)
    return (
      <Modal open={true} size="small" className={theme.modalWithSidePanel} onClose={onClose}>
        <ErrorDisplay />
      </Modal>
    );

  return (
    <Modal open={true} className={theme.modalWithSidePanel} onClose={onClose}>
      <div className={theme.container}>
        {sidePanel()}
        <div className={theme.content}>{sectionOnDisplay.component}</div>
      </div>
    </Modal>
  );
};

export default ModalWithSidePanel;
